import {
  Accordion, Column, Drawer, Heading, Input, List, Page, Row, Select, Spacer, Text, Toggle,
} from '@oliasoft-open-source/react-ui-library';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import translations from 'client/internationalization/translation-map.json';

const pullTasks = [
  {
    id: '298392839',
    name: 'API Name Here',
    period: '24 hours',
    lastPulled: '2023-12-20T09:00:00',
  },
  {
    id: '5688234',
    name: 'Another Connection Name Here',
    period: undefined,
    lastPulled: undefined,
  },
];
const pushTasks = [
  {
    id: '938439489',
    name: 'Yet Another Connection Name Here',
    period: '7 days',
    lastPushed: '2023-12-13T10:43:00',
  },
];

export const TaskManager = () => {
  const [activeTask, setActiveTask] = useState<{ [key: string]: any }>();

  const { t } = useTranslation();

  const pullHeader = { id: 0, name: `${t(translations.connections_pull)}`, type: 'Heading' };
  const pushHeader = { id: 1, name: `${t(translations.connections_push)}`, type: 'Heading' };

  const pullTaskList = pullTasks.map(task => ({
    ...task,
    active: task === activeTask,
    onClick: () => setActiveTask(task),
    actions: [{
      type: 'Menu',
      subActions: [{
        label: '',
        onClick: () => {},
      }],
    }],
    metadata:
  <>
    <div>{task.period ? `${t(translations.connections_pulledEvery)} ${task.period}` : `${t(translations.connections_manual)}`}</div>
    <div>{task.lastPulled ? `${t(translations.connections_lastPulled)} ${new Date(task.lastPulled).toLocaleString()}` : `${t(translations.connections_neverPulled)}`}</div>
  </>,
  }));
  const pushTaskList = pushTasks.map(task => ({
    ...task,
    active: task === activeTask,
    onClick: () => setActiveTask(task),
    actions: [{
      type: 'Menu',
      subActions: [{
        label: '',
        onClick: () => {},
      }],
    }],
    metadata:
  <>
    <div>{task.period ? `${t(translations.connections_pushedEvery)} ${task.period}` : `${t(translations.connections_manual)}`}</div>
    <div>{task.lastPushed ? `${t(translations.connections_lastPushed)} ${new Date(task.lastPushed).toLocaleString()}` : `${t(translations.connections_neverPushed)}`}</div>
  </>,
  }));

  const items: any = [
    pullHeader,
    ...pullTaskList,
    pushHeader,
    ...pushTaskList,
  ];

  const taskView = activeTask ? (
    <>
      <Heading top>{activeTask.name}</Heading>
      <Text bold>{t(translations.name)}</Text>
      <Input value={activeTask.name} width={300} />
      <Spacer />
      <Accordion heading={<Heading>{t(translations.connections_connectionDetails)}</Heading>} managed expanded>
        <Text bold>{t(translations.connections_connectionType)}</Text>
        <Select value={0} options={[{ label: 'Connection type here', value: 0 }]} width={300} />
        <Spacer />
        <Text bold>{t(translations.connections_host)}</Text>
        <Input value="https://api.hostnamehere.com" width={300} />
        <Spacer />
        <Text bold>{t(translations.user)}</Text>
        <Input value="usernamegoeshere" width={300} />
        <Spacer />
        <Text bold>{t(translations.password)}</Text>
        <Input value="***************" width={300} />
      </Accordion>
      <Spacer />
      <Accordion heading={<Heading>{t(translations.connections_automation)}</Heading>} managed expanded>
        <Toggle
          label={t(translations.connections_repeatAutomatically)}
          checked={activeTask.period}
          onChange={() => {}}
        />
        <Spacer />
        {activeTask.period && (
        <>
          <Text bold>{t(translations.connections_frequency)}</Text>
          <Select value={0} options={[{ label: `${activeTask.period}`, value: 0 }]} width={300} />
          <Spacer />
          <Text bold>{t(translations.time)}</Text>
          <Column>
            <Row>
              <Select width={70} value={9} options={Array.from(Array(24).keys()).map((_, index) => ({ value: index, label: index > 9 ? index : `0${index}` }))} />
              <Select width={70} value={0} options={Array.from(Array(12).keys()).map((_, index) => ({ value: index, label: index * 5 > 9 ? index * 5 : `0${index * 5}` }))} />
            </Row>
          </Column>
        </>
        )}
      </Accordion>
    </>
  ) : null;

  return (
    <Page padding={false} scroll={false}>
      <Row spacing={0} height="100%">
        <Drawer button={false} open background="var(--color-neutral-50)">
          <List
            drawer
            list={{
              name: 'Connections',
              actions: [{
                icon: 'add',
                label: 'Add',
                onClick: () => {},
                primary: true,
              }],
              items,
            }}
          />
        </Drawer>
        <Column scroll padding borderLeft>
          {taskView}
        </Column>
      </Row>
    </Page>
  );
};